<script lang="ts">
	import { format } from 'svelte-i18n';

	import type { Device } from 'src/types/Device';
	import { getDeviceImage } from 'src/helpers/device_state_view_helpers';

	export let device: Device;
	export let slotIndex: number | null | undefined;

	$: cameraImage = device ? getDeviceImage(device) : undefined;
	$: cameraLabel = $format('camera', { default: 'Camera' });
	$: slotEyebrow =
		slotIndex == null
			? $format('activate_storage_available_slot', { default: 'Available slot' })
			: $format('activate_storage_slot_label', {
					default: `Slot ${slotIndex + 1}`,
					values: { number: slotIndex + 1 },
				});
</script>

<div
	class="camera-slot-assignment d-flex align-items-stretch gap-s"
	aria-label={$format('text_camera_slot_assignment_aria', {
		default: 'Camera storage slot assignment',
	})}
>
	<div class="camera-slot-assignment__widget camera-slot-assignment__camera">
		<div class="camera-slot-assignment__avatar">
			{#if cameraImage}
				<img src={cameraImage} alt={device?.name || cameraLabel} />
			{:else}
				<i class="fas fa-camera"></i>
			{/if}
		</div>
		<div class="camera-slot-assignment__copy">
			<span>{cameraLabel}</span>
			<strong>{device?.name || $format('text_your_camera', { default: 'Your camera' })}</strong>
		</div>
	</div>

	<div class="camera-slot-assignment__arrow" aria-hidden="true">
		<i class="fas fa-arrow-right"></i>
	</div>

	<div class="camera-slot-assignment__widget camera-slot-assignment__slot">
		<div class="camera-slot-assignment__slot-icon">
			<i class="fas fa-plus"></i>
		</div>
		<div class="camera-slot-assignment__copy">
			<span>{slotEyebrow}</span>
			<strong>
				{$format('activate_storage_empty_slot', { default: 'Empty storage slot' })}
			</strong>
		</div>
	</div>
</div>

<style>
	.camera-slot-assignment {
		width: 100%;
	}

	.camera-slot-assignment__widget {
		display: flex;
		flex: 1 1 0;
		align-items: center;
		gap: 14px;
		min-width: 0;
		min-height: 92px;
		padding: 16px;
		background: rgba(255, 255, 255, 0.035);
		border: 1px solid rgba(255, 255, 255, 0.11);
		border-radius: var(--radius-big);
		box-sizing: border-box;
	}

	.camera-slot-assignment__camera {
		box-shadow: 0 16px 34px -30px rgba(255, 255, 255, 0.45);
	}

	.camera-slot-assignment__avatar,
	.camera-slot-assignment__slot-icon {
		display: grid;
		width: 58px;
		height: 58px;
		place-items: center;
		flex-shrink: 0;
		overflow: hidden;
		color: #ffffff;
		font-size: 20px;
		background: rgba(255, 255, 255, 0.08);
		border-radius: 15px;
	}

	.camera-slot-assignment__avatar img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.camera-slot-assignment__copy {
		display: flex;
		min-width: 0;
		flex-direction: column;
		gap: 4px;
	}

	.camera-slot-assignment__copy span {
		color: rgba(255, 255, 255, 0.5);
		font-size: 11px;
		font-weight: 700;
		letter-spacing: 0.07em;
		text-transform: uppercase;
	}

	.camera-slot-assignment__copy strong {
		overflow: hidden;
		font-size: 16px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.camera-slot-assignment__arrow {
		display: flex;
		flex: 0 0 68px;
		align-items: center;
		justify-content: center;
		color: rgba(255, 255, 255, 0.58);
	}

	.camera-slot-assignment__arrow i {
		font-size: 22px;
	}

	.camera-slot-assignment__slot {
		background:
			radial-gradient(110% 170% at 100% 100%, rgba(255, 255, 255, 0.06) 0%, transparent 65%),
			rgba(255, 255, 255, 0.025);
		border-color: rgba(255, 255, 255, 0.24);
		border-style: dashed;
	}

	@media (max-width: 620px) {
		.camera-slot-assignment {
			flex-direction: column;
			gap: 10px;
		}

		.camera-slot-assignment__arrow {
			flex-basis: auto;
			height: 28px;
			transform: rotate(90deg);
		}

		.camera-slot-assignment__widget {
			min-height: 82px;
		}
	}
</style>
